/**
 * @fileoverview CSS module for global modal context.
 * This module contains styles for the global modal context, including transition animations.
 */

.transition_enter {
    opacity: 0;
}

.transition_enter_active {
    opacity: 1;
    transition: all 300ms;
}

.transition_exit {
    opacity: 1;
}

.transition_exit_active {
    opacity: 0;
    transition: all 300ms;
}
